var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.25,
    stroke: "#273943",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.834 20.797 31.045 13h-1.74l-6.25 6.757L17.998 13h-5.926l7.706 10.299L12 31.709h1.74l6.819-7.37 5.517 7.37h5.926l-8.167-10.912h-.001Zm-9.216-6.528h2.71l12.059 16.134h-2.71L14.618 14.27Z",
    fill: "#000"
  })));
};
export default SvgTwitter;